import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { Box } from "@mui/material";

import Styles from "./App.module.css";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";

const App: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className={Styles.main_container}>
      <Box className={Styles.nav_container}>
        <Navbar />
      </Box>

      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>

      <Box className={Styles.footer_container}>
        <Footer />
      </Box>
    </Box>
  );
};

export default App;